export default __webpack_public_path__ + "static/media/work-tab-icon.908e64c9.svg";